export const setProject = (project) => ({
  type: 'SET_PROJECT',
  project,
});
